/* global common */
import { sendGoogleEvent, sendRequest, getCdnUrl } from '@html/_common/utils';

export default function AOScoutNewsletterSignupForm(baseSelector, newsletterType = 'SERP_banner', ampEventType = null, submitCallback = null, cancelCallback = null, errorCallback = null) {
  const INPUT_SELECTOR = `${baseSelector} .js-ao-scout-newsletter-form__input`;
  const SUBMIT_SELECTOR = `${baseSelector} .js-ao-scout-newsletter-form__input-button--submit`;
  const CANCEL_SELECTOR = `${baseSelector} .js-ao-scout-newsletter-form__input-button--cancel`;
  const FORM_SELECTOR = `${baseSelector} .js-ao-scout-newsletter-form__form-container`;
  const CHECKBOX_SELECTOR = `${baseSelector} .js-ao-scout-newsletter-form__checkbox .js-aa-checkbox__input`;
  const MESSAGE_SELECTOR = `${baseSelector} .js-ao-scout-newsletter-form__message`;
  const ALREADY_SIGNED_UP_SELECTOR = `${baseSelector} .js-ao-scout-newsletter-form__already-signed-up`;
  const FINE_PRINT_LINKS_SELECTOR = `${baseSelector} .js-ao-scout-newsletter-form__fine-print`;
  const IMAGE_CONTAINER_SELECTOR = '.js-ao-email-aquisition-popup__image-container';
  const HIDDEN_CLASS = 'hid';
  const NEWSLETTER_SUBSCRIBE_ENDPOINT = '/api/subscribe/check';

  const CONTEST_SEO_NAME = $(IMAGE_CONTAINER_SELECTOR).data('seo-name');
  const CONTEST_ENDPOINTS = {
    getHash: `/api/travel/${CONTEST_SEO_NAME}/generate-hash`,
    addEmail: `/api/travel/${CONTEST_SEO_NAME}/add-email`,
    addContest: `/api/travel/${CONTEST_SEO_NAME}/add-tour`,
  };
  const SIGNUP_TYPE = $(FORM_SELECTOR).attr('data-signup-type');

  const commonJs = typeof sendGoogleEvent !== 'undefined' ? { sendGoogleEvent, sendRequest, getCdnUrl } : common;

  const getInputValues = () => {
    const $inputs = $(INPUT_SELECTOR);
    // If empty template is displayed the inital banner is in DOM but hidden
    // checking if the value is in the second input
    const email = $inputs.eq(0).val() || $inputs.eq(1).val();
    const isChecked = $(CHECKBOX_SELECTOR).prop('checked');

    return { email, isChecked };
  };

  const onSuccess = () => {
    $(FORM_SELECTOR).addClass(HIDDEN_CLASS);
    $(INPUT_SELECTOR).each(() => $(this).val(''));
    $(MESSAGE_SELECTOR).removeClass(HIDDEN_CLASS);
    if (submitCallback) submitCallback();

    commonJs.sendGoogleEvent(
      'Newsletter - Signup',
      'SignedUp',
      'SERP',
      {
        newsletter_type: newsletterType,
        ampEventName: 'newsletter_subscribed',
      },
    );
  };

  const onAlreadySignedUp = () => {
    $(FORM_SELECTOR).addClass(HIDDEN_CLASS);
    $(INPUT_SELECTOR).each(() => $(this).val(''));
    $(ALREADY_SIGNED_UP_SELECTOR).removeClass(HIDDEN_CLASS);
    if (submitCallback) submitCallback();
  };

  const subscribeToNewsLetter = (event) => {
    event.preventDefault();

    const { email } = getInputValues();
    if (!email) return;

    $(SUBMIT_SELECTOR).prop('disabled', true);
    commonJs.sendRequest(
      NEWSLETTER_SUBSCRIBE_ENDPOINT,
      { email },
      (response) => {
        if (response.status !== 'OK') {
          if (errorCallback) errorCallback(response);
          return;
        }

        onSuccess();
      },
    );
  };

  const addContest = (hash, tour, source) => {
    commonJs.sendRequest(
      CONTEST_ENDPOINTS.addContest,
      { hash, tour, source },
      (response) => {
        if (response.status !== 'OK') {
          if (errorCallback) errorCallback(response);
          return;
        }
        onSuccess();
        commonJs.sendGoogleEvent(
          'Newsletter - Signup',
          'SignedUp',
          'Contest',
          {
            ampEventName: 'contest_form_completed',
            contestUserID: CONTEST_SEO_NAME,
          },
        );
      },
    );
  };

  const addEmail = (email, doubleOptIn, hash, tourId) => {
    commonJs.sendRequest(
      CONTEST_ENDPOINTS.addEmail,
      {
        email, hash, doubleOptIn, liked: 0, phash: '',
      },
      (response) => {
        if (response.status === 'blocked') onAlreadySignedUp();
        if (response.status !== 'OK') {
          if (errorCallback) errorCallback(response);
          return;
        }
        addContest(hash, tourId, 'popup');
      },
    );
  };

  const getHash = (email, isChecked) => {
    commonJs.sendRequest(
      CONTEST_ENDPOINTS.getHash,
      {},
      (response) => {
        if (!response.success) {
          if (errorCallback) errorCallback(response);
          return;
        }
        addEmail(email, isChecked, response.hash, response.tourId);
      },
      { type: 'GET' },
    );
  };

  const signupForContest = (event) => {
    event.preventDefault();

    const { email } = getInputValues();
    const { isChecked } = getInputValues();
    if (!email || ($(CHECKBOX_SELECTOR).length && !isChecked)) return;

    $(SUBMIT_SELECTOR).prop('disabled', true);
    getHash(email, isChecked);
  };

  const cancel = () => {
    if (!cancelCallback) return;
    cancelCallback();
  };

  const handleFinePrintClick = (event) => {
    if (!ampEventType) return;

    const $target = $(event.target);
    const type = $target.data('type');

    commonJs.sendGoogleEvent(
      undefined,
      undefined,
      undefined,
      {
        ampEventName: `${ampEventType}_${type}_clicked`,
      },
    );
  };

  const signupActions = {
    newsletter: (event) => subscribeToNewsLetter(event),
    contest: (event) => signupForContest(event),
  };

  const attachEventListeners = () => {
    const $form = $(FORM_SELECTOR);
    if (!$form) return;
    $('body').on('submit', FORM_SELECTOR, signupActions[SIGNUP_TYPE]);

    $('body').on('click', FINE_PRINT_LINKS_SELECTOR, handleFinePrintClick);

    if (!$(CANCEL_SELECTOR).length) return;
    $('body').on('click', CANCEL_SELECTOR, cancel);
  };

  const setBackgroundImage = () => {
    const backgroundImageUrl = $(IMAGE_CONTAINER_SELECTOR).data('background-image-url');

    if (!backgroundImageUrl) return;

    $(IMAGE_CONTAINER_SELECTOR).css('background-image', `url(${backgroundImageUrl})`);
  };

  this.initiate = () => {
    setBackgroundImage();
    attachEventListeners();
  };
}
